import { Validators } from "@angular/forms";

import { ValidationErrorKey } from "../../validators/general-validation.";
import {
  FormFieldInput,
  HtmlInputMode,
  HtmlInputType,
  InputFormFieldInit,
} from "../input";

export class FormFieldInputNumber extends FormFieldInput {
  public min?: number;
  public max?: number;

  constructor(init: InputFormFieldInit<FormFieldInputNumber>) {
    init.inputType = init.inputType ?? HtmlInputType.NUMBER;
    init.inputMode = init.inputMode ?? HtmlInputMode.NUMERIC; // TODO: We should test the behavior of this on some actual devices
    super(init);

    const min = init.min ?? 0;
    const max = init.max ?? Infinity;

    this.validators = [
      Validators.min(min),
      Validators.max(max),
      ...(init.validators || []),
    ];

    super.addErrorMessages({
      [ValidationErrorKey.MIN]: $localize`Bitte geben Sie eine Zahl ein, welche grösser als ${min}:Minimum value: ist.`,
      [ValidationErrorKey.MAX]: $localize`Bitte geben Sie eine Zahl ein, welche kleiner gleich ${max}:Maximum value: ist.`,
    });

    super.addInputHtmlAttribute("min", min.toString());
    super.addInputHtmlAttribute("max", max.toString());
  }
}
